import clsx from 'clsx';
import React from 'react';
import './UiLoader.css';
export function UiLoader(_a) {
    var fill = _a.fill, color = _a.color, size = _a.size;
    color = color || 'primary';
    size = size || 8;
    var style = {
        height: size,
        width: size,
    };
    if (fill) {
        style.backgroundColor = fill;
    }
    return (React.createElement("div", { className: clsx('UiLoader', "color-" + color) },
        React.createElement("div", { style: style }),
        React.createElement("div", { style: style }),
        React.createElement("div", { style: style })));
}
